import { fetchEventSource, FetchEventSourceInit } from "@microsoft/fetch-event-source";

export interface StreamJsonOptions<T = any> extends Omit<FetchEventSourceInit, "onmessage" | "headers"> {
  token?: string | null;
  headers?: Record<string, string>;
  onJson?: (payload: T, eventName: string) => void;
  onDone?: () => void;
  onRaw?: (event: any) => void;
}

export const streamJson = async <T = any>(url: string, options: StreamJsonOptions<T>) => {
  const { token, headers, onJson, onDone, onRaw, ...rest } = options;

  return fetchEventSource(url, {
    ...rest,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...headers,
    },
    openWhenHidden: rest.openWhenHidden ?? true,
    onmessage: (event) => {
      onRaw?.(event);
      if (!event.data) return;
      if (event.data === "[DONE]") {
        onDone?.();
        return;
      }
      try {
        onJson?.(JSON.parse(event.data), event.event);
      } catch {
        // Some legacy endpoints may emit plain text keep-alives.
      }
    },
  });
};
